{
  "schema_version": "1.0",
  "run_id": "run_20260712_130000_ist",
  "edition_key": "2026-07-12-1300-Asia-Kolkata",
  "created_at": "2026-07-12T07:30:10Z",
  "feed_health": [
    {
      "feed_id": "the-hindu-national",
      "url": "https://www.thehindu.com/news/national/feeder/default.rss",
      "status": "ok",
      "http_status": 200,
      "fetched_at": "2026-07-12T07:30:02Z",
      "item_count": 8,
      "error": null
    },
    {
      "feed_id": "indian-express-india",
      "url": "https://indianexpress.com/feed/",
      "status": "ok",
      "http_status": 200,
      "fetched_at": "2026-07-12T07:30:03Z",
      "item_count": 6,
      "error": null
    },
    {
      "feed_id": "ndtv-latest",
      "url": "https://www.ndtv.com/rss/latest",
      "status": "ok",
      "http_status": 200,
      "fetched_at": "2026-07-12T07:30:04Z",
      "item_count": 10,
      "error": null
    }
  ],
  "candidates": [
    {
      "story_id": "sha256:story-001",
      "source_id": "the-hindu-national",
      "publisher": "The Hindu",
      "title": "Cabinet approves ₹12,000 crore green hydrogen mission",
      "summary": "The Union Cabinet approved the National Green Hydrogen Mission with an outlay of ₹12,000 crore aimed at making India a global hub for production and export.",
      "canonical_url": "https://www.thehindu.com/news/national/green-hydrogen-mission-approved/article1.ece",
      "published_at": "2026-07-12T06:15:00Z",
      "retrieved_at": "2026-07-12T07:30:02Z",
      "language": "en",
      "fresh": true,
      "source_snapshot_path": "source_snapshots/story-001.json",
      "dedupe_key": "sha256:dedupe-001"
    },
    {
      "story_id": "sha256:story-002",
      "source_id": "indian-express-india",
      "publisher": "Indian Express",
      "title": "RBI holds repo rate at 5.5%, maintains accommodative stance",
      "summary": "The Reserve Bank of India's Monetary Policy Committee voted to keep the repo rate unchanged at 5.5% citing stable inflation trends.",
      "canonical_url": "https://indianexpress.com/article/business/rbi-repo-rate-hold-2026/",
      "published_at": "2026-07-12T05:45:00Z",
      "retrieved_at": "2026-07-12T07:30:03Z",
      "language": "en",
      "fresh": true,
      "source_snapshot_path": "source_snapshots/story-002.json",
      "dedupe_key": "sha256:dedupe-002"
    },
    {
      "story_id": "sha256:story-003",
      "source_id": "ndtv-latest",
      "publisher": "NDTV",
      "title": "Monsoon reaches Delhi two days ahead of normal onset date",
      "summary": "The India Meteorological Department announced that the southwest monsoon arrived in Delhi on July 10, two days before the normal onset date of July 12.",
      "canonical_url": "https://www.ndtv.com/india-news/monsoon-reaches-delhi-ahead-of-schedule-2026/",
      "published_at": "2026-07-12T04:30:00Z",
      "retrieved_at": "2026-07-12T07:30:04Z",
      "language": "en",
      "fresh": true,
      "source_snapshot_path": "source_snapshots/story-003.json",
      "dedupe_key": "sha256:dedupe-003"
    }
  ]
}
